var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCustomerSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.454,
    height: 20.454,
    viewBox: "0 0 20.454 20.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-headset",
    "data-name": "Icon awesome-headset",
    d: "M7.67,8.309A1.279,1.279,0,0,0,6.392,7.031H5.753A2.557,2.557,0,0,0,3.2,9.588v1.918a2.557,2.557,0,0,0,2.557,2.557h.639A1.279,1.279,0,0,0,7.67,12.784ZM14.7,14.062a2.557,2.557,0,0,0,2.557-2.557V9.588A2.557,2.557,0,0,0,14.7,7.031h-.639a1.279,1.279,0,0,0-1.278,1.278v4.474a1.279,1.279,0,0,0,1.278,1.278ZM10.227,0A10.421,10.421,0,0,0,0,10.227v.639H1.918v-.639a8.309,8.309,0,1,1,16.619,0h0c0,.1,0,6.62,0,6.62a1.689,1.689,0,0,1-1.689,1.689H12.784a1.918,1.918,0,0,0-1.918-1.918H9.588a1.918,1.918,0,1,0,0,3.835h7.26a3.607,3.607,0,0,0,3.607-3.607v-6.62A10.421,10.421,0,0,0,10.227,0Z",
    fill: "#c5c9f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerSupport);
export default __webpack_public_path__ + "static/media/icon-customer-support.76a72ab1fbcf973fb864c2d9bc3f01ec.svg";
export { ForwardRef as ReactComponent };